import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import { hideModal } from 'appSrc/redux/actions';
import style from './styles/style.module.css';

import FacebookShare from '../Facebook';
import TwitterShare from '../Twitter';
import PinterestShare from '../Pinterest';
import Embed from '../Embed';

class ShareGroupPopup extends PureComponent {
    render() {
        const { modalName, modalProps } = this.props;
        const isOpen = modalProps.modalIsOpen && modalName === 'shareGroupPopup';

        return (
            <ReactModal
            isOpen={ isOpen }
            contentLabel="Share"
            onRequestClose={ this.props.closeModal }
            className={ 'modal-popup ' + style.shareGroupPopup }
            overlayClassName='modal-overlay' >
                <div className={ `${ style.content }` } style={ this.props.style }>
                    <FacebookShare trackShare={ modalProps.trackShare } { ...modalProps.facebookProps } />
                    <TwitterShare trackShare={ modalProps.trackShare } { ...modalProps.twitterProps } />
                    { modalProps.pinterestProps &&
                        <PinterestShare trackShare={ modalProps.trackShare } { ...modalProps.pinterestProps } />
                    }
                    { modalProps.embed &&
                        <Embed trackShare={ modalProps.trackShare } list={ modalProps.embed } />
                    }
                </div>
            </ReactModal>
        );
    }
}

const mapStateToProps = ( state ) => {
    return {
        self: state.self.user,
        modalName: state.modal.modalName,
        modalProps: state.modal.modalProps,
    };
};
const mapDispatchToProps = ( dispatch ) => {
    return {
        closeModal: () => {
            dispatch( hideModal( 'shareGroupPopup' ) );
        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( ShareGroupPopup );
